module.exports = __webpack_public_path__ + "img/rys-down-bg.2a0c2d20.png";